import './StyledButton.scss';


function StyledButton({ style, children, onClick, className, ...otherProps })
{
    return (
        <button className={`StyledButton ${className || ""}`} onClick={onClick} style={style} {...otherProps}>{children}</button>
    );
}

export default StyledButton;
